import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { Box, Button, Checkbox, CssBaseline, Grid, IconButton, List, ListItem, ListItemText, Modal, TextField, ThemeProvider, Tooltip, Typography } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { ContextNotification, severitys } from '../../../App';
import customtheme from '../../../themes';
import { useSelector } from 'react-redux';
import RtlProvider from "../../../Components/RtlProvider"
import helper from "../../../helper";
import BeatLoading from "../../../Components/Loader/BeatLoader";
import { RiDeleteBin5Fill } from "react-icons/ri";
import ConfirmationDialog from '../../../Components/ConfirmationDialog';
import packageApi from "../../../api/packageApi";
import { TbEdit, TbPlaylistAdd } from "react-icons/tb";
import { BiTrip } from "react-icons/bi";
import CustomTitle from "../../../Components/CustomTitle";
import staticData from "../../../data/StaticData";
import PackageDetail from "./PackageDetail";
import EditNewPackageDetail from "./EditNewPackageDetail";

const AddPackage = () => {

    const { open, setOpen } = useContext(ContextNotification);
    const [isloading, setIsloading] = useState(false);
    const customization = useSelector((state) => state.customization);
    const [PackageDetails, setPackageDetails] = useState([]);
    const [duration, setDuration] = useState(0);
    const [stepper, setStepper] = useState(0);
    const [isFinished, setIsFinished] = useState(false);
    const [defaultValues, setDefaultValues] = useState(null)

    const schema = yup.object().shape({
        packageTitle: yup.string().trim().required(" عنوان برنامه سفر را وارد نمائید"),
        duration: yup.number().positive(" مدت اقامت را وارد نمائید")
    });
    const { register, setValue, handleSubmit, formState: { errors }, control, resetField, reset, getValues, watch } = useForm({
        resolver: yupResolver(schema),
    });

    useEffect(() => {
        RefreshForm();
    }, []);

    const AddPackageDetail = (packageDetaildata) => {
        if ((packageDetaildata.title !== '') && (packageDetaildata.events?.length > 0)) {
            var newStep = PackageDetails.length > 0 ? Math.max(...PackageDetails.map(a => { return a.step })) + 1 : 1;
            const newitem = {
                "step": newStep,
                "title": packageDetaildata.title,
                "events": packageDetaildata.events
            }
            setPackageDetails([...PackageDetails, newitem]);
        }

    }
    const EditPackageDetail = (packageDetaildata) => {
        if ((packageDetaildata.title !== '') && (packageDetaildata.events?.length > 0)) {
            if (PackageDetails?.find((item) => item.step === stepper)) {
                setPackageDetails([...PackageDetails?.filter((item) => item.step !== stepper),
                {
                    "step": stepper,
                    "title": packageDetaildata.title,
                    "events": packageDetaildata.events
                }])
            }
        }

    }
    const AddEditPackage = (detailValue) => {
        if (PackageDetails?.find((item) => item.step === stepper)) {
            EditPackageDetail(detailValue);
        }
        else {
            AddPackageDetail(detailValue);
        }
    }

    const Pre = (detailValue) => {
        AddEditPackage(detailValue);
        var newstep = stepper > 1 ? stepper - 1 : 1;
        if (PackageDetails?.find((item) => item.step === newstep)) {
            setDefaultValues(PackageDetails?.find((item) => item.step === newstep));
        }
        else
            setDefaultValues(null);

        setStepper(newstep);
    }
    const Next = (detailValue) => {
        AddEditPackage(detailValue);
        var newstep = stepper + 1;
        if (PackageDetails?.find((item) => item.step === newstep)) {
            setDefaultValues(PackageDetails?.find((item) => item.step === newstep));
        }
        else
            setDefaultValues(null);
        setStepper(newstep);
    }

    const Finish = (detailValue) => {
        AddEditPackage(detailValue);
        setIsFinished(true);

    }

    const AddPackage = () => {

        let packagename = null;
        if (watch("packageTitle"))
            packagename = watch("packageTitle");

        const data = {
            "name": packagename,
            "duration": duration,
            "details": PackageDetails
        }
        setIsloading(true);
        packageApi.CustomCreate(data).then((res) => {

            if (res.data.success) {
                setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.success });
                RefreshForm();
            }
            else {
                setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
            }
        }).catch(err => {
            if (err.response && err.response.data && err.response.data.errors) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
            }
            else if (err.response && err.response.data) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
            }
            else if (err.message) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
            }
            else {
                setOpen({ IsEnable: true, Message: JSON.stringify(err), severity: severitys.error });
            }
        }
        ).finally(() => setIsloading(false));

    }

    const onSubmit = () => {
        AddPackage();
        RefreshForm();
    }

    const RefreshForm = () => {
        setStepper(0);
        setIsFinished(false);
        setValue("packageTitle", null);
        setDuration(0);
        setPackageDetails([]);
        setDefaultValues(null);
        setSelectedPackageDetail(null);
    }





    const handledurationChange = (event) => {
        var num = Number(event.target.value);
        if (Number.isNaN(num) || (num < 0))
            num = 0;
        setDuration(num);
    }

    //////////EditDetail
    const [selectedPackageDetail, setSelectedPackageDetail] = useState(null);
    const [showEditPackageModal, setShowEditPackageModal] = useState(false);
    const handleOpenEditPackageDetail = (itm) => {
        setSelectedPackageDetail(itm);
        setShowEditPackageModal(true);
    }
    const handleCloseEditPackageDetail = () => {
        setSelectedPackageDetail(null);
        setShowEditPackageModal(false);
    }
    const handleEditPackageDetail = (detaildata) => {
        var selectedstep = selectedPackageDetail?.step;
        setPackageDetails([...PackageDetails.filter((itm) => itm.step !== selectedstep),
        {
            "step": selectedstep,
            "title": detaildata.title,
            "events": detaildata.events
        }
        ]);
    handleCloseEditPackageDetail();
    }
    const modalStyle = {
        position: 'absolute',
        display: 'flex',
        overflowX: 'auto',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '60%',
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
        pt: 2,
        px: 2,
        pb: 2,
        overflow: 'scroll',

    };
    //////////DeleteDetail  
    const RemovePackageDetail = (step) => {

        const removedDetail = PackageDetails.filter((a) => a.step !== step);
        var newstep = -1;
        const newDetail = removedDetail.sort((a, b) => a.step >= b.step ? 1 : -1).map((itm) => {
            newstep = newstep + 1;
            return {
                "step": newstep,
                "title": itm.title,
                "events": itm.events
            }

        });
        setPackageDetails(newDetail);
    }

    return (
        <ThemeProvider theme={customtheme(customization)}>
            <RtlProvider>
                <CustomTitle title={'افزودن برنامه سفر'} icon={<BiTrip size={24} />} />
                <form onSubmit={handleSubmit(onSubmit)} >
                    {((isFinished) || (stepper === 0)) && <>
                        <Grid container spacing={1}>
                            <Grid item md={12} xs={12}>
                                <TextField label="عنوان برنامه سفر" margin="normal" focused={true} onChange={(e) => { }} {...register("packageTitle")} sx={{ width: "40%" }} ></TextField>
                                <p className="error">{errors.packageTitle?.message}</p>
                            </Grid>
                            <Grid item md={3} xs={4}>
                                <TextField
                                    type='number'
                                    value={duration}
                                    onChange={handledurationChange}
                                    label="مدت اقامت (روز)"
                                />

                               {(watch("packageTitle"))&&<Tooltip title={'افزودن مرحله سفر'}>
                                    <IconButton disabled={isFinished} edge="end" sx={{ mt: 1 }} aria-label=" مرحله سفر" onClick={() => { setStepper(1) }}>
                                        <TbPlaylistAdd color='#4a148c' size={24} />
                                    </IconButton>
                                </Tooltip>} 
                                <p className="error">{errors.duration?.message}</p>
                            </Grid>
                            
                        </Grid>
                        {(PackageDetails?.length > 0) && <>
                            <Typography component="h1" variant="h5" mt={2} mb={2} ml={1}  >
                                لیست مراحل سفر
                            </Typography>
                            <Box style={{ display: 'flex', border: '1px solid gray', borderRadius: 7 }} sx={{ mt: 1 }}>
                                <List sx={{ width: '100%' }}>
                                    {PackageDetails?.sort((a, b) => a.step >= b.step ? 1 : -1).map((itm, index) => {
                                        return (
                                            <ListItem key={index} >
                                                <Grid container spacing={2}>
                                                    <Grid item md={2} xs={2}>
                                                        <ListItemText sx={{ ml: 2 }} primary={' روز ' + staticData.Recorder[itm.step]} />
                                                    </Grid>
                                                    <Grid item md={7} xs={7}>
                                                        <ListItemText sx={{ ml: 2 }} primary={itm.title} />
                                                    </Grid>

                                                    <Grid item md={1} xs={1}>
                                                        <IconButton disabled={isloading} edge="end" aria-label="حذف" onClick={() => { RemovePackageDetail(itm.step) }}>
                                                            <BeatLoading loading={isloading} color={"#e65100"} size={8} />
                                                            <RiDeleteBin5Fill color='#C7253E' />
                                                        </IconButton>
                                                    </Grid>
                                                    <Grid item md={1} xs={1}>
                                                        <Tooltip title="ویرایش" placement="top">
                                                    <IconButton style={{ margin: '2px', borderRadius: 0 }} onClick={() => {
                                                        handleOpenEditPackageDetail(itm);
                                                    }}>
                                                        <TbEdit color='#4a148c' />
                                                    </IconButton>
                                                </Tooltip>
                                                    </Grid>
                                                </Grid>
                                                
                                            </ListItem>
                                        )
                                    })
                                    }
                                </List>
                            </Box>
                        </>}
                        {(isFinished) && (PackageDetails?.length > 0) && <Button
                                type="submit"
                                style={{
                                    fontSize: "18px",
                                    width: "10rem",
                                    height: "3rem",
                                    backgroundColor: "#127c69ff",
                                    color: "white",
                                }}
                                sx={{ mt: 1 }}
                                disabled={(isloading)}

                            >
                                <BeatLoading loading={isloading} color={"#e65100"} size={8} />
                                ثبت  برنامه سفر                                 </Button>}

                    </>}
                    {(stepper > 0) && (!isFinished) && <>
              <Typography component="h1" variant="h5"
                sx={{ color:"#0f5a4cff", display: "flex", alignItems: "center", fontSize: '19px', fontFamily: 'BTitr !important',ml:3 ,mb:1}}>
                        {watch("packageTitle")}</Typography>
                                                        <CssBaseline/>
                    <Box style={{ display: 'flex', border: '1px solid gray', borderRadius: 7 }} sx={{ backgroundColor: '#ecfcffff', mt: 2 }}>
                        
                        <PackageDetail
                            Step={stepper}
                            Next={(packageDetail) => Next(packageDetail)}
                            Pre={(packageDetail) => { Pre(packageDetail) }}
                            Finish={(packageDetail) => Finish(packageDetail)}
                            DefaultValues={defaultValues} />
                    </Box>
                    </>}
                </form>
                <Modal
                    alignItems='center'
                    open={showEditPackageModal}
                    onClose={handleCloseEditPackageDetail}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={modalStyle}>

                        <EditNewPackageDetail PackageDetail={selectedPackageDetail} EditPackageDetail={(detaildata) => { handleEditPackageDetail(detaildata) }} Refresh={() => { }} />

                    </Box>
                </Modal>

            </RtlProvider>
        </ThemeProvider>
    );

}
export default AddPackage;